import { useOverlays } from "contexts/OverlayContext";
import { CashItemImporterDrawer } from "./CashItemImporterDrawer";

export const ManualCashItemImportDrawerWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("manualCashItemImport");

    if (!overlayInfo) {
        return null;
    }

    return (
        <CashItemImporterDrawer
            key={overlayInfo.instanceId}
            open={!overlayIsClosing}
            onClose={closeOverlay}
            initialFinancialAccountId={overlayInfo.data?.financialAccountId}
        />
    );
};
